<template>
  <v-app id="base">
    <router-view />
  </v-app>
</template>

<style>
#base {
  background: url("/static/SCOUT/bg_scout.svg") no-repeat fixed !important;
  background-size: cover !important;
  height: 100% !important;
  width: auto !important;
}
</style>

<script>
export default {
  name: "App",
  components: {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {}
};
</script>